import * as React from "react";
import { Image } from "react-bootstrap";
import {IMAGES} from "@kopjra/uikit";

export interface Props {
    size: number;
}

export const WASpinner: React.FC<Props> = ({ size }) => {
    return <object type="image/svg+xml" data={IMAGES["web-forensics"].animated.dark} style={{width: size}}><Image src={IMAGES["web-forensics"].animated.dark} height={size}/></object>;
};